var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: " app-container" },
    [
      _c("bread-crumb", {
        attrs: {
          path: "/resource",
          title: _vm.activeName === "task" ? "任务中心" : "消息通知"
        }
      }),
      _c(
        "div",
        { staticClass: "message-agent" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "red_tabs tabs-pad",
              on: {
                "tab-click": function($event) {
                  return _vm.tabClickFn($event)
                }
              },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "我的任务（" + _vm.taskMesage + "）",
                    name: "task"
                  }
                },
                [
                  _c("my-task", {
                    ref: "MyTask",
                    attrs: {
                      switchType: _vm.switchType,
                      systemModuleArr: _vm.systemModuleArr,
                      systemModuleMap: _vm.systemModuleMap
                    },
                    on: { changTaskCount: _vm.changTaskCount }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label:
                      "消息通知（" +
                      _vm.$store.getters.messageUpdateEvent +
                      "条未读）",
                    name: "message"
                  }
                },
                [
                  _c("message-notice", {
                    ref: "MessageNotice",
                    attrs: {
                      systemModuleArr: _vm.systemModuleArr,
                      systemModuleMap: _vm.systemModuleMap
                    },
                    on: { refreshMessage: _vm.refreshMessageFn }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName === "task",
                  expression: "activeName === 'task'"
                }
              ],
              staticClass: "message-agent-select",
              on: { click: _vm.switchTypeClick }
            },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": _vm.switchType === "卡片切换" ? "card" : "list"
                }
              }),
              _c(
                "el-tooltip",
                { attrs: { content: _vm.switchType, placement: "bottom" } },
                [
                  _c("span", { staticClass: "message-agent-select-txt" }, [
                    _vm._v(_vm._s(_vm.switchType))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }